function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, Ref, ElementType, CSSProperties, ComponentType } from 'react';
import cn from 'classnames';
import { IIconProps } from '../Icon';
import { Breadcrumb } from './Breadcrumb/Breadcrumb';
require("./Breadcrumbs.css");
var styles = {
  "Root": "Breadcrumbs-module-Root_SHl",
  "List": "Breadcrumbs-module-List_1HW",
  "Popup": "Breadcrumbs-module-Popup_2SX"
};
export const Breadcrumbs = ({
  'aria-label': ariaLabel = 'Навигационная цепочка',
  className,
  controlRef,
  innerRef,
  items,
  linkComponent = 'a',
  separatorIcon = 'chevronRight',
  style = {},
  tag = 'nav',
  ...props
}) => {
  const Component = tag;
  if (!items || items.length === 0) return null;
  return /*#__PURE__*/React.createElement(Component, _extends({
    style: style,
    className: cn(styles.Root, className),
    ref: innerRef || controlRef,
    "aria-label": ariaLabel
  }, props), /*#__PURE__*/React.createElement("ol", {
    itemScope: true,
    itemType: "https://schema.org/BreadcrumbList",
    className: styles.List
  }, items.map((item, i) => /*#__PURE__*/React.createElement(Breadcrumb, {
    isCurrent: items.length - 1 === i,
    key: i,
    label: item.label,
    linkComponent: linkComponent,
    separatorIcon: separatorIcon,
    subList: item.children,
    to: item.to
  }))));
};
if (process.env.NODE_ENV !== 'production') {
  Breadcrumbs.displayName = 'Breadcrumbs';
}